import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  getMissionBalanceSheetWithSlugTokenQuery,
  saveEvaluationMissionQuery,
  getMissionBalanceSheetWithSlugIdQuery,
  createMissionBalancesheetWithIdQuery,
} from "./queries";
import { MISSION_STATUS, QUERY_STATUS } from "constants/constants";

const MissionBalancesheetContext = createContext({});

export const useMissionBalancesheetContext = () =>
  useContext(MissionBalancesheetContext);

export const MissionBalancesheetProvider = ({ ...props }) => {
  const [missionBalancesheet, setMissionBalancesheet] = useState({});
  const [createdBalancesheetMission, setCreatedBalancesheetMission] = useState(
    {}
  );

  const [consultantMissionBalancesheet, setConsultantMissionBalancesheet] =
    useState({});
  const [savedMission, setSavedMission] = useState({});
  const [missionStatus, setMissionStatus] = useState("");
  const [mailMissionEvalStatus, setMailMissionEvalStatus] = useState("");

  const getMissionBalanceSheetWithSlugToken = useCallback(
    async ({ token, slug }) => {
      try {
        setMissionStatus(QUERY_STATUS.LOADING);
        const result = await getMissionBalanceSheetWithSlugTokenQuery({
          token,
          slug,
        });
        setMissionBalancesheet(result);
        setMissionStatus(QUERY_STATUS.SUCCESS);
      } catch (e) {
        setMissionStatus(QUERY_STATUS.ERROR);
        console.error("getMissionBalanceSheetWithSlugToken", e);
        throw e;
      }
    },
    []
  );

  const createMissionBalancesheetWithId = useCallback(
    async ({ missionId, data }) => {
      try {
        setMailMissionEvalStatus(QUERY_STATUS.LOADING);
        const result = await createMissionBalancesheetWithIdQuery({
          missionId,
          data,
        });
        setCreatedBalancesheetMission(result);
        setMailMissionEvalStatus(QUERY_STATUS.SUCCESS);

        return result;
      } catch (e) {
        setMailMissionEvalStatus(QUERY_STATUS.ERROR);

        console.error("createMissionBalanceSheetWithId", e);
        throw e;
      }
    },
    []
  );

  const getMissionBalanceSheetWithSlugId = useCallback(
    async ({ missionId, evaluationId }) => {
      try {
        setMissionStatus(QUERY_STATUS.LOADING);
        const result = await getMissionBalanceSheetWithSlugIdQuery({
          missionId,
          evaluationId,
        });
        setConsultantMissionBalancesheet(result);
      } catch (e) {
        console.error("getMissionBalanceSheetWithSlugId", e);
        throw e;
      }
    },
    []
  );
  const saveEvaluationMission = useCallback(async (data) => {
    try {
      setMissionStatus(QUERY_STATUS.LOADING);
      const result = await saveEvaluationMissionQuery({
        id: data.id,
        data: data,
      });
      setSavedMission(result);
      setMissionStatus(result?.action);
    } catch (e) {
      setMissionStatus(MISSION_STATUS.ERROR_SAVING);
      console.error("saveEvaluationMission", e);
      throw e;
    }
  }, []);

  const values = useMemo(
    () => ({
      getMissionBalanceSheetWithSlugToken,
      missionBalancesheet,
      saveEvaluationMission,
      savedMission,
      setSavedMission,
      missionStatus,
      getMissionBalanceSheetWithSlugId,
      consultantMissionBalancesheet,
      createMissionBalancesheetWithId,
      mailMissionEvalStatus,
    }),
    [
      missionBalancesheet,
      savedMission,
      missionStatus,
      consultantMissionBalancesheet,
      createdBalancesheetMission,
      mailMissionEvalStatus,
    ]
  );

  return <MissionBalancesheetContext.Provider value={values} {...props} />;
};
